// Partner referral links and the visit / "Get it for free" counters of the demo stores.
// A partner shares https://<demo>.ownezzy.com/?ref=CODE; the code is kept for 30 days and sent with the sign-up,
// so the new store owner becomes that partner's customer (backend: routes/onboarding.js).
const REF_KEY = "oz_ref";
const REF_DAYS = 30;

function storage(kind) {
  try { return window[kind]; } catch { return null; }
}

export function captureReferral() {
  const code = new URLSearchParams(window.location.search).get("ref");
  if (!code || !/^[A-Za-z2-9]{8}$/.test(code)) return;
  try { storage("localStorage").setItem(REF_KEY, JSON.stringify({ code: code.toUpperCase(), until: Date.now() + REF_DAYS * 86400000 })); } catch { /* storage blocked */ }
}

export function referralCode() {
  try {
    const saved = JSON.parse(storage("localStorage").getItem(REF_KEY) || "null");
    return saved && saved.until > Date.now() ? saved.code : "";
  } catch {
    return "";
  }
}

// This page's address with the partner's code kept on it, for "Share this website"
export function shareUrl() {
  const code = referralCode();
  return `${window.location.origin}/${code ? `?ref=${code}` : ""}`;
}

const API = process.env.REACT_APP_API_URL || "/api";
function send(event, site) {
  const body = JSON.stringify({ event, site });
  try {
    if (navigator.sendBeacon && navigator.sendBeacon(`${API}/analytics/event`, new Blob([body], { type: "application/json" }))) return;
  } catch { /* fall back to fetch */ }
  fetch(`${API}/analytics/event`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
}

// One visit per browser session per store
export function trackVisit(site) {
  if (!site) return;
  const key = `oz_visit_${site}`;
  const session = storage("sessionStorage");
  try { if (session && session.getItem(key)) return; session && session.setItem(key, "1"); } catch { /* count anyway */ }
  send("visit", site);
}

export const trackGetFreeClick = (site) => site && send("get_free_click", site);
export const trackTrialContinueClick = (site) => site && send("trial_continue_click", site);
